import { global } from ":shared/app";
import { _internal } from "../store";
const endpoint = "flavor/badge";
export type GET = {
  returns: {
    tracks: Record<string, { bg: string; text: string }>;
  };
};

export async function get(): Promise<GET["returns"]> {
  return global.api.getAuth(endpoint).then((res) => {
    _internal.setBadge(res.data);
    return res.data;
  });
}
